import { Signuture } from './FormSignature'

export const FormSignaturePrint = ({ value, title, ...props }) => {
  return <Signuture {...props} signature={value} />
}
